import React from 'react';

import {PageNotFound} from '../pages/PageNotFound.page';
import {createRoutesHook} from '../router';

const LazyMeetingFlow = React.lazy(() =>
    import('../pages/MeetingFlow.page').then(({MeetingFlow}) => ({
        default: MeetingFlow,
    })),
);

const LazyHome = React.lazy(() =>
    import('../pages/Home.page').then(({Home}) => ({
        default: Home,
    })),
);

export const useMainRoutes = createRoutesHook([
    {
        path: '/m',
        node: LazyMeetingFlow,
    },
    {
        exact: true,
        path: '/',
        node: LazyHome,
    },
    {
        path: '',
        fallback: true,
        node: PageNotFound,
    },
]);
